import { TextArea } from '@picsart/design-system/components/TextArea';

import useStyles from './styles';
import type { InputProps } from './types';

const Input = ({
  label,
  error,
  multiline = true,
  placeholder,
  value,
  disabled,
  onChange,
}: InputProps) => {
  const classes = useStyles();

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value);
  };

  const inputId = label
    ? `input-${label.toLowerCase().replace(/\s+/g, '-')}`
    : undefined;

  return (
    <div className={classes.root}>
      {label && (
        <label className={classes.label} htmlFor={inputId}>
          {label}
        </label>
      )}
      <TextArea
        size="large"
        id={inputId}
        value={value ?? ''}
        isWithoutBackground
        isDisabled={disabled}
        dataTestId={inputId}
        onChange={handleChange}
        placeholder={placeholder}
        {...(error && { status: 'error' })}
        customHeight={multiline ? 110 : 55}
      />
      {error && <span className={classes.error}>{error}</span>}
    </div>
  );
};

export default Input;
